import type { GetterTree } from 'vuex'
import type { RootState } from '../../state'
import type { PhrasesState } from './state'
import type { PhraseGroup, Phrase } from '@/models/phrases'

export const getters: GetterTree<PhrasesState, RootState> = {
  getPhrasesGroups(state): PhraseGroup[] {
    return state.groups
  },
  getPhrases(state): Record<string, Phrase[] | undefined> {
    return state.phrasesByGroup
  },
  getPhrasesByGroup: state => (groupId: string): Phrase[] | undefined => {
    return state.phrasesByGroup[groupId]
  },
}
